import React from 'react';

const Member = props => (
  <div className={"col-sm-6 col-lg-3 m-15px-tb"}>
    <div className={"our-team"}>
      <div className={"team-img black-after"}>
        <picture>
          <source type="image/webp" srcSet={props.webp}/>
          <source type="image/png" srcSet={props.src}/>
          <img
            data-src={props.src}
            title={props.name}
            alt="member"
            loading={"lazy"}
            width={421}
            height={421}
            className={"resize-img lazyload"}
          />
        </picture>
          <div className={"team-desc text-center"}>
            <p className={"white-color"}>{props.description}</p>
            <div className={"social-icon si-30 white radius nav justify-content-center"}>
              <a href={props.twitter} target={"_blank"} rel={"noopener noreferrer"} aria-label={"Twitter"}>
                <i className={"fab fa-twitter"}/>
              </a>
              <a href={props.linkedin} target={"_blank"} rel={"noopener noreferrer"} aria-label={"LinkedIn"}>
                <i className={"fab fa-linkedin-in"}/>
              </a>
            </div>
          </div>
      </div>
      <div className={"team-info text-center"}>
        <h2 className={"m-5px-b"}>{props.name}</h2>
        <p className={"m-0px font-1"}>{props.position}</p>
      </div>
    </div>
  </div>
);

export default Member;
